import _defineProperty from "/home/runner/work/site/site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/site/site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/site/site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["as"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as l from "react";
import * as m from "react-dom";

var a = function a() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      o = _ref.multiSources;

  var e = {
    element: null,
    set: null
  },
      u = function u(t) {
    e.element = t, e.set && e.set.current && e.set.current(t);
  };

  return {
    Source: function Source(_ref2) {
      var t = _ref2.children;

      var _l$useState = l.useState(null),
          _l$useState2 = _slicedToArray(_l$useState, 2),
          n = _l$useState2[0],
          s = _l$useState2[1];

      return l.useLayoutEffect(function () {
        var c = {
          current: s
        };
        var r;
        return e.set && (r = e.set, !o && e.set.current && e.set.current(null)), e.set = c, e.element !== void 0 && s(e.element), function () {
          c.current = null, e.set = null, r && r.current && (e.set = r, e.element !== void 0 && r.current(e.element));
        };
      }, []), n ? m.createPortal(t, n) : null;
    },
    Target: function Target(_ref3) {
      var _ref3$as = _ref3.as,
          t = _ref3$as === void 0 ? "div" : _ref3$as,
          n = _objectWithoutProperties(_ref3, _excluded);

      return l.createElement(t, _objectSpread({
        ref: u
      }, n));
    },
    useTargetRef: function useTargetRef() {
      return u;
    }
  };
};

export { a as createTeleporter };